import React from 'react';

import { GradientDot, IconLightBulb1, IconLightning } from '@trqk/components';
import { locale } from '@trqk/utils';

import { CardWrapper } from '.';

import { mainIconWidth, mainGradientDotWidth } from '../constants';

/**
 * An Insights card that displays a tip about which performances earn the most.
 */
export const DidYouKnowCard = (): JSX.Element => (
        <CardWrapper>
            <div className="absolute">
                <div className="relative" style={{ top: 20, left: 20 }}>
                    <IconLightning fillColor="primary-500" width={24} />
                </div>
            </div>
            <div className="flex flex-col items-center justify-center mt-8">
                <GradientDot
                    width={mainGradientDotWidth}
                    gradientColor="highlight-gold"
                >
                    <IconLightBulb1
                        width={mainIconWidth}
                        fillColor="highlight-gold"
                    />
                </GradientDot>
                <h4 className="mt-4 mb-2">
                    {locale.enUS.INSIGHTS.CARDS.DID_YOU_KNOW.TITLE}
                </h4>
                <div className="m-10 text-center leading-loose">
                    {locale.enUS.INSIGHTS.CARDS.DID_YOU_KNOW.BODY.PART_1}&nbsp;
                    <span className="font-bold">
                        {locale.enUS.INSIGHTS.CARDS.DID_YOU_KNOW.BODY.PART_2}
                    </span>
                    &nbsp;
                    {locale.enUS.INSIGHTS.CARDS.DID_YOU_KNOW.BODY.PART_3}&nbsp;
                    <span className="font-bold">
                        {locale.enUS.INSIGHTS.CARDS.DID_YOU_KNOW.BODY.PART_4}
                    </span>
                    &nbsp;
                </div>
            </div>
        </CardWrapper>
    );
